module.exports = {
	"articleTitle1": "Sweetwaters coffee shop to move into old Borders space",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Sweetwaters Coffee & Tea",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/sweetwaters-joins-businesses-open-old-borders-building",
	"articleSnippet1": "Nov 13, 2013 ... University students who enjoy the Sweetwaters Coffee & Tea locations \nthroughout Ann Arbor will soon have an option much closer to Central ...",
	"articleSnippet2": "Jul 9, 2014 ... Monday, Sweetwaters Coffee & Tea opened its fourth Ann Arbor location in one \nsection of the former Borders building on E. Liberty and ...",
	"foodRecommendations": [],
	"articleTitle2": "Local cafe opens new East Liberty location",
	"address": "123 W Washington St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2803,
		"lng": -83.74975
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/sweetwaterswashington.json
// module id = 986
// module chunks = 0